import { gql } from '@apollo/client'

export const GET_STORE_AREAS = gql`
  query GetStoreAreas {
    storeAreas {
      id
      name
      defaultForStoreSize
    }
  }
`
